<template>
  <div class="Exporthk2">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn
          type="button"
          @click="
            exportexcelhk2(
              tokenexport,
              exportthn,
              exportbln,
              exportps,
              paparnegeriexport
            )
          "
          color="blue white white--text"
        >
          <span class="material-icons">file_download</span>
          {{ $t("muatturun") }} {{ $t("hk2") }}
        </v-btn> -->
            <download-excel
              :data = "papardatahk2"
              type="csv"
              name="hk2.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("hk2") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatahk2"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exporthk2",
  setup() {},
  props: [
    "papardatahk2",
    "exportthn",
    "exportbln",
    "exportps",
    "paparnegeriexport",
  ],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem("tokenexport"),
    databatch: "",
    headers: [
      { text: "Bil", value:"Bil"},
      { text: "HID", value:"HID"},
      { text: "BNO", value:"BNO"},
      { text: "Pusingan", value:"Pusingan"},
      { text: "S", value:"S"},
      { text: "NG", value:"NG"},
      { text: "DP", value:"DP"},
      { text: "DB", value:"DB"},
      { text: "BP", value:"BP"},
      { text: "ST", value:"ST"},
      { text: "NOTK", value:"NOTK"},
      { text: "NOIR", value:"NOIR"},
      { text: "NOAIR", value:"NOAIR"},
      // { text: "KAW", value:"KAW"},
      // { text: "Bulan", value:"Bulan"},
      // { text: "Tahun", value:"Tahun"},
      // { text: "BPK", value:"BPK"},
      // { text: "IDBPK", value:"IDBPK"},
      { text: "HK2PK", value:"HK2PK"},
      { text: "HK2C1", value:"HK2C1"},
      { text: "HK2C2", value:"HK2C2"},
      { text: "HK2C3", value:"HK2C3"},
      { text: "HK2C4", value:"HK2C4"},
      { text: "HK2C4a", value:"HK2C4a"},
      { text: "HK2C4b", value:"HK2C4b"},
      { text: "HK2C5", value:"HK2C5"},
      //{ text: "PENHK2", value:"PENHK2"},
      { text: "P", value:"P"},
      { text: "HK221A_i", value:"HK221A_i"},
      { text: "HK2INCS21A_i", value:"HK2INCS21A_i"},
      { text: "HK221A_ii", value:"HK221A_ii"},
      { text: "HK2INCS21A_ii", value:"HK2INCS21A_ii"},
      { text: "HK221A_iii", value:"HK221A_iii"},
      { text: "HK2INCS21A_iii", value:"HK2INCS21A_iii"},
      { text: "HK2INCS21a", value:"HK2INCS21a"},
      { text: "HK2PN", value:"HK2PN"},
      { text: "HK2M", value:"HK2M"},
      { text: "HK2S38", value:"HK2S38"},
      { text: "HK2S39", value:"HK2S39"},
      { text: "HK2B1", value:"HK2B1"},
      { text: "HK2B2", value:"HK2B2"},
      { text: "HK2A1", value:"HK2A1"},
      { text: "HK2A2", value:"HK2A2"},
      { text: "HK2KL", value:"HK2KL"},
      // { text: "dateMula", value:"dateMula"},
      // { text: "dateTamat", value:"dateTamat"},
    ],
  }),
  methods: {
    async exportexcelhk2(
      tokenexport,
      exportthn,
      exportbln,
      exportps,
      paparnegeriexport
    ) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/sec/checksession`, {
            tokenexportsess: window.localStorage.getItem("tokenexport"),
          })
          .then((result) => {
            console.log(result.data.status);
            if (result.data.status) {
              window.open(
                `${process.env.VUE_APP_API_URL}/HK/exporthk2serverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`,
                "_blank"
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>